import { gql } from '../../__generated__/gql'

export const COMMUNITY_CONSOLIDATED_NOTIFICATIONS_DETAILS_QUERY = gql(`
  query communityConsolidatedNotificationDetails($notificationId: String!) {
    communityConsolidatedNotificationDetails(notificationId: $notificationId) {
      id
      actionPerformers {
        id
        firstName
        notifiedAt
        picture
      }
    }
  }
`)
